<template>
  <div>
    <div class="toolbar">
      <el-input
        v-model="returnNo"
        clearable
        placeholder="单号"
        style="width:180px"
        @keyup.enter.native="load"
      />
      <el-date-picker
        v-model="returnRange"
        type="daterange"
        value-format="yyyy-MM-dd"
        start-placeholder="退货开始"
        end-placeholder="退货结束"
        style="width:260px"
        @change="load"
      />
      <el-button type="primary" icon="el-icon-search" @click="load">查询</el-button>
    </div>

    <el-table :data="pageList" border v-loading="loading">
      <el-table-column prop="returnNo" label="单号" width="160" show-overflow-tooltip />
      <el-table-column prop="projectName" label="项目" min-width="140" show-overflow-tooltip />
      <el-table-column prop="remark" label="备注" min-width="140" show-overflow-tooltip>
        <template slot-scope="{ row }">{{ row.remark || '-' }}</template>
      </el-table-column>
      <el-table-column prop="createdByName" label="退货人" width="100" show-overflow-tooltip>
        <template slot-scope="{ row }">{{ row.createdByName || '-' }}</template>
      </el-table-column>
      <el-table-column prop="createdByPhone" label="联系电话" width="120">
        <template slot-scope="{ row }">{{ row.createdByPhone || '-' }}</template>
      </el-table-column>
      <el-table-column label="退货时间" width="120">
        <template slot-scope="{ row }">{{ fmtDate(row.createdAt) }}</template>
      </el-table-column>
      <el-table-column label="操作" width="90" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openDetail(row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="listTotal"
      :page="page"
      :page-size="pageSize"
      @current-change="onPageChange"
      @size-change="onPageSizeChange"
    />

    <el-drawer title="退货详情" :visible.sync="detailVisible" size="780px">
      <div v-if="detail" style="padding:0 16px 16px">
        <p>单号：{{ (detail.return || {}).returnNo }}</p>
        <p>项目：{{ (detail.return || {}).projectName }}</p>
        <p>
          退货人：{{ (detail.return || {}).createdByName || '-' }}
          · {{ (detail.return || {}).createdByPhone || detail.createdByPhone || '-' }}
          · {{ fmtDate((detail.return || {}).createdAt) }}
        </p>
        <p v-if="(detail.return || {}).remark">备注：{{ detail.return.remark }}</p>
        <el-table :data="detail.lines" border size="small">
          <el-table-column prop="receiveNo" label="收货单号" width="140" show-overflow-tooltip>
            <template slot-scope="{ row }">{{ row.receiveNo || '-' }}</template>
          </el-table-column>
          <el-table-column prop="reqNo" label="申请单号" width="140" show-overflow-tooltip>
            <template slot-scope="{ row }">{{ row.reqNo || '-' }}</template>
          </el-table-column>
          <el-table-column prop="materialName" label="材料" min-width="120" show-overflow-tooltip />
          <el-table-column label="规格" width="120" show-overflow-tooltip>
            <template slot-scope="{ row }">{{ row.specs || row.spec || '-' }}</template>
          </el-table-column>
          <el-table-column prop="unit" label="单位" width="70" align="center" />
          <el-table-column prop="qty" label="退货数量" width="90" />
          <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip>
            <template slot-scope="{ row }">{{ row.remark || '-' }}</template>
          </el-table-column>
        </el-table>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { listMaterialReturns, getMaterialReturn } from '../../api/supply'
import ListPagination from '../../components/ListPagination.vue'
import listPaging from '../../mixins/listPaging'

export default {
  name: 'SupplierReturn',
  components: { ListPagination },
  mixins: [listPaging],
  data() {
    return {
      returnNo: '',
      returnRange: null,
      list: [],
      loading: false,
      detailVisible: false,
      detail: null
    }
  },
  created() {
    this.load()
  },
  methods: {
    fmtDate(v) {
      if (!v) return '-'
      return String(v).slice(0, 10)
    },
    async load() {
      this.loading = true
      try {
        const range = this.returnRange || []
        const res = await listMaterialReturns({
          returnNo: this.returnNo || undefined,
          startDate: range[0] || undefined,
          endDate: range[1] || undefined
        })
        this.list = res.data || []
        this.page = 1
      } finally {
        this.loading = false
      }
    },
    async openDetail(row) {
      const res = await getMaterialReturn(row.id)
      this.detail = res.data
      if (this.detail && this.detail.return && !this.detail.return.createdByPhone) {
        this.detail.createdByPhone = row.createdByPhone
      }
      this.detailVisible = true
    }
  }
}
</script>

<style scoped>
.toolbar { display: flex; gap: 8px; margin-bottom: 12px; flex-wrap: wrap; }
</style>
